import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Select from '~components/ui/Select'
import RoundedIcon from '~components/ui/RoundedIcon'

class RefineBy extends Component {
  constructor () {
    super()

    this.state = {
      open: false,
      colours: []
    }
  }

  componentDidMount () {
    this.mapColoursToOptions()
  }

  mapColoursToOptions () {
    const { colours } = this.props
    const options = colours.map(({ code, name }) => (
      { name, value: code }
    ))

    this.setState({
      colours: options
    })
  }

  handleColourOptionChange ({ target }) {
    const { value } = target
    const { onColourChange } = this.props

    if (onColourChange && value) {
      onColourChange(value)
    }
  }

  toggleOverlay (e) {
    const open = this.state.open

    this.setState((state) => {
      return { open: !open }
    })

    // Temporary until permanent solution found
    document.body.classList.toggle('overflow-y-hidden')
    this.props.onClick && this.props.onClick()
  }

  render () {
    return (
      <>
        <button type="button" className={classNames('transition-colors duration-150 ease-in-out h-12 px-4 cursor-pointer border-grey border rounded outline-none focus:border-charcoal hover:border-charcoal', this.props.className)} onClick={() => this.toggleOverlay()}>
          {this.props.text}
        </button>

        <div className={classNames('w-full h-full bg-white top-0 left-0 right-0 z-50 py-4 overflow-y-scroll', { fixed: this.state.open }, { hidden: !this.state.open })}>
          <div className="px-4 mx-auto xxl:container md:px-8 xxl:px-0 overflow-scrolling">
            <button type="button" className="block w-10 h-10 mb-6 ml-auto group" onClick={() => this.toggleOverlay()}>
              <RoundedIcon name="crossAlt" className="block w-10 h-10" />
            </button>

            <div className="flex flex-wrap -mx-2 -my-3">
              <div className="w-full px-2 my-3 md:w-1/2">
                <Select
                  placeholder="UK sizing"
                  items={this.props.sizingModes}
                  onChange={this.props.onSizingModeChange}
                  value={this.props.selectedSizingMode || ''}
                  className="w-full"
                />
              </div>

              <div className="w-full px-2 my-3 md:w-1/2">
                <Select
                  placeholder="Colours"
                  items={this.state.colours}
                  onChange={(e) => this.handleColourOptionChange(e)}
                  value={this.props.selectedColour || ''}
                  className="w-full"
                />
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

RefineBy.propTypes = {
  text: PropTypes.string.isRequired,
  colours: PropTypes.array.isRequired,
  selectedColour: PropTypes.string,
  onColourChange: PropTypes.func,
  sizingModes: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    name: PropTypes.string
  })).isRequired,
  onSizingModeChange: PropTypes.func,
  selectedSizingMode: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func
}

export default RefineBy
